<!--
 * @Description: 对账联系函
 * @Autor: txp
 * @Date: 2021-05-07 11:28:36
-->
<template>
  <div class="reconciliation">
    <el-card class="box-card">
      <div class="mtb20 ft12 C787878">
        <span>服务中心：</span>
        <span
          ><a href="#" class="text-decoration_none themColor" @click="goBack"
            >返回上一页</a
          ></span
        >
        <span class="el-icon-arrow-right"></span>
        <span>发货详情</span>
      </div>
      <div class="container">
         <div class="flex flex-j-c-space-between mgb20">
         <span class="label">订单编号：<span class="value">{{deliveryDetail.orderCode}}</span></span>
         <span class="label">发货明细单号：<span class="value">{{deliveryDetail.deliveryCode}}</span></span>
         <span class="label">商品总数：<span class="vaule">{{deliveryDetail.actualNum}}</span></span>
         <span class="label">发货时间：<span>{{deliveryDetail.moveDate}}</span></span>
         <span class="label">收货地址：<span>{{deliveryDetail.pickAdress}}</span></span>
      </div>
        <div class="flex flex-j-c-space-between flex-a-i-center">
         <span class="label">备注：<span class="value">{{deliveryDetail.remarks}}</span></span>
      </div>
      </div>
      <div class="table-container"  v-loading="loading"
             element-loading-spinner="el-icon-loading">
        <el-table
            ref="orderTableId" 
            :data="table_data"
            :header-cell-style="{textAlign: 'center',fontSize:'13px',color:'#787878',background:'#F5F5F5'}"
            :cell-style="{textAlign:'center',fontSize:'14px',color:'#1D1D1D',lineHeight:'24px'}">
            <el-table-column
                  label="商品图片">
                  <template slot-scope="scope">
                     <img style="width: 100px;" :src="scope.row.picUrl" />
                  </template>
            </el-table-column>
            <el-table-column
                  label="商品名称" prop="productName">
            </el-table-column>
            <!-- <el-table-column
                  label="商品类型" prop="lineTypeName">
            </el-table-column> -->
            <el-table-column
                  label="规格" prop="spec">
            </el-table-column>
            <el-table-column
                  label="单位" prop="salesUnitName">
            </el-table-column>
            <el-table-column
                  label="数量" prop="actualNum">
            </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex"; //主题的引用
import { deliverGoodsList,mdmdictdata } from "@/api/api";
export default {
  name: "reconciliation",
  data() {
    return {
      table_data: [],
      deliveryDetail: {},
      orderCode: '',
      deliveryCode: '',
      loading: false,
      lineTypeData: []
    };
  },
  computed: {
    ...mapGetters({
      theme: "theme",
    }),
  },
  components: {
    // DeliveryDetailsInfoItems
  },
  created(){
    this.deliveryDetail = this.$route.params.detail
     if(!this.deliveryDetail) {
      this.$router.back()
    }
    this.orderCode = this.deliveryDetail.orderCode
    this.deliveryCode = this.deliveryDetail.deliveryCode
    this.lineTypedatas()
    
  },
  mounted() {
    
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.back()
    },
        // 获取行项目数据字典
    async lineTypedatas() {
      await mdmdictdata({
        dictTypeCode: 'dms_order_line_type'
      }).then((res) => {
        if (res.code == 200) {
          this.lineTypeData = res.result
          this.getDeliveryDetail()
        }
      })
    },
    /**
     * 获取发货明细
     */
    async getDeliveryDetail() {
      this.loading = true
      const res = await deliverGoodsList({orderCode: this.orderCode,deliveryCode: this.deliveryCode})
      this.loading = false
      this.table_data = res.result.data.map(item=>{
         try {
            item.lineTypeName = item.lineType
              ? this.lineTypeData.find((it) => it.dictCode == item.lineType).dictValue
              : ''
          } catch {
            item.lineTypeName = ''
          }
          return item
      })
    }
  },
};
</script>
<style lang="scss" scoped>
 .container{
    // padding: 20px;
    // border: 1px solid rgb(223, 223, 223);
    border-radius: 10px;
    margin-top: 20px;
    .label{
      font-size: 14px;
    }
    .time{
      font-size: 12px;
    }
    .red{
      color: red;
    }
    .mgb20{
      margin-bottom: 20px;
    }
    .flex {
      display: flex;
    }
    .flex-j-c-space-between{
      justify-content: space-between;
    }
    .flex-a-i-center{
      align-items: center;
    }
  }
  .table-container{
    margin-top: 20px;
  }
</style>
